/* @flow */
import {pick, isEqual} from 'lodash';
import {toURL, ROOT_PATHS} from '@homeaway/search-url-parser';
import type {Root, SearchRequest} from '@homeaway/search-url-parser';

type Props = {
    pathname: string,
    search?: string
};

type SERPURLOptions = {
    siteName: string,
    pathname?: string,
    root?: Root
};

const {DEFAULT_ROOT, SEARCH_ROOT, SERP_ROOT} = ROOT_PATHS;
const SEARCH_ROOT_PATH_BRANDS = ['homeaway_sg', 'homeaway_jp'];
const SERP_ROOT_REGEX = new RegExp(/^\/s(([\/?#]).*)?$/);

export const getUri = ({pathname, search}: Props) => {
    return `${pathname}${search || ''}`;
};

export const requestsHaveEquivalentLocaleParam = (
    a?: SearchRequest,
    b?: SearchRequest
): boolean => {
    const aPicked = pick(a, 'locale');
    const bPicked = pick(b, 'locale');

    return isEqual(aPicked, bPicked);
};

export const getSiteRootPath = (siteName: string): Root =>
    SEARCH_ROOT_PATH_BRANDS.includes(siteName.toLowerCase())
        ? SEARCH_ROOT
        : DEFAULT_ROOT;

export const toSERPURL = (
    searchRequest: SearchRequest,
    options: SERPURLOptions
) => {
    const {siteName, pathname = '', root} = options;
    const useSERPRoot = SERP_ROOT_REGEX.test(pathname);
    const rootPath =
        root || (useSERPRoot ? SERP_ROOT : getSiteRootPath(siteName));

    return toURL(searchRequest, {name: siteName}, {root: rootPath});
};
